var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInjiVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.782,
    height: 39.632,
    viewBox: "0 0 104.782 39.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8f00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.539,
    y1: -7.174,
    x2: -0.493,
    y2: -7.174,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58128",
    "data-name": "Group 58128",
    transform: "translate(-225 -46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landscape_Inji_Logo_Scalable",
    transform: "translate(225 46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57553",
    "data-name": "Group 57553",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155574",
    "data-name": "Path 155574",
    d: "M313.953,248.41h-8.461a3.063,3.063,0,0,0-3.062,3.062v.958a3.063,3.063,0,0,0,3.062,3.062h8.461a1.6,1.6,0,0,0,1.6-1.593v-3.891A1.6,1.6,0,0,0,313.953,248.41Zm-7.978,5.6a2.064,2.064,0,1,1,2.064-2.064A2.064,2.064,0,0,1,305.975,254.012Z",
    transform: "translate(-278.566 -228.71)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155575",
    "data-name": "Path 155575",
    d: "M111.719,147.978h7.74v-2.308a8.708,8.708,0,0,0-8.71-8.709H93.2a8.708,8.708,0,0,0-8.71,8.709V147.8H88.7l1.821-4.7h6.11a1.888,1.888,0,1,1-.035,1.7H91.684l-1.821,4.7H84.49v2.926h8.083a1.887,1.887,0,1,1,0,1.7H84.49V157h5.374l1.821,4.7H100a1.885,1.885,0,1,1,.035,1.7H90.521L88.7,158.7H84.49v1.687A8.708,8.708,0,0,0,93.2,169.1h17.55a8.708,8.708,0,0,0,8.71-8.709v-2.96h-7.74a4.724,4.724,0,0,1,0-9.449Z",
    transform: "translate(-84.49 -129.463)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155576",
    "data-name": "Path 155576",
    d: "M217.49,93.591h15.092s-.2-3.127-2.583-3.467S217.49,93.591,217.49,93.591Z",
    transform: "translate(-202.927 -87.737)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155577",
    "data-name": "Path 155577",
    d: "M174.37,73.85l10.956-3.365s-1.349-2.25-3.152-1.967S174.37,73.85,174.37,73.85Z",
    transform: "translate(-164.528 -68.494)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M492.706,191.555H488.73V175.16h3.976Zm5.543,0h-3.975V175.168h5.9q5.244,0,7.824,2.347t2.58,7.379v6.662H506.6v-7.211a4.819,4.819,0,0,0-1.755-4.165,7.643,7.643,0,0,0-4.631-1.289h-1.966v12.664Zm21.584-7.612v-5.054h-7.867v-3.721h11.843v9.324a6.649,6.649,0,0,1-1.988,5.032,6.486,6.486,0,0,1-3.043,1.649,19.226,19.226,0,0,1-4.144.381h-2.8v-3.722h3.341q4.653,0,4.653-3.89m9.307,7.612h-3.978V175.168h3.975Z",
    transform: "translate(-445.367 -165.625)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57585",
    "data-name": "Group 57585",
    transform: "translate(268.691 75.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155579",
    "data-name": "Path 155579",
    d: "M4.1-13.068,0-22.165H2.214l3.372,7.507h.165l3.372-7.507h2.214l-4.1,9.1Zm8.13,0v-9.1H22.2v1.654H14.262v2.01h7.2v1.654h-7.2v2.125H22.2v1.654Zm11.374,0v-9.1h7.621a3.142,3.142,0,0,1,2.195.712A2.783,2.783,0,0,1,34.2-19.29a2.97,2.97,0,0,1-.573,1.934A2.566,2.566,0,0,1,32-16.478l2.1,3.41H31.782l-1.947-3.346h-4.2v3.346Zm7.379-7.443H25.637v2.43l5.344.013a1.21,1.21,0,0,0,.859-.28,1.247,1.247,0,0,0,.3-.942,1.244,1.244,0,0,0-.3-.948A1.228,1.228,0,0,0,30.98-20.511Zm4.746,7.443v-9.1h2.036v9.1Zm3.817,0v-9.1h9.72v1.654H41.579v2.519h6.692v1.654H41.579v3.27Zm15.051,0v-3.244l-4.084-5.853h2.4l2.672,4.344,3.246-4.344h2.257l-4.448,5.84v3.257Z",
    transform: "translate(0 22.165)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjiVerify);
export default __webpack_public_path__ + "static/media/inji-verify.076e9ba1808664e3ab195490086b3245.svg";
export { ForwardRef as ReactComponent };